import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pl-4" }

import { SELECTABLE_TRACKING_SERVICE } from '@/services/consts/operation_office';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrackingServiceForm',
  props: {
    modelValue: {},
    isManagementOffice: { type: Boolean },
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!

  return (__props.isManagementOffice)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "text-form pl-4 pr-3 mb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: __props.windowInnerWidth > 800 ? 2 : 3
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.trackingService')), 1)
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                items: _unref(SELECTABLE_TRACKING_SERVICE),
                modelValue: modelValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})